import firebase from 'firebase/app';
import 'firebase/functions';
import 'firebase/firestore';
import 'firebase/analytics'
import ReactPixel from 'react-facebook-pixel';

//firebase.analytics();
// const firebaseConfig = {
// 	apiKey: 'AIzaSyBTzHguR3bWAduNCaAQGIgqO_f7gADBQFc',
// 	projectId: 'bequickr-b9626'
// };

// REAL
const firebaseConfig = {
  apiKey: "AIzaSyBTzHguR3bWAduNCaAQGIgqO_f7gADBQFc",
  authDomain: "bequickr-b9626.firebaseapp.com",
  databaseURL: "https://bequickr-b9626.firebaseio.com",
  projectId: "bequickr-b9626",
  storageBucket: "bequickr-b9626.appspot.com",
  messagingSenderId: "503350359384",
  appId: "1:503350359384:web:12606e6cde836f76d5a12d",
  measurementId: "G-B2KHSMDDWW"
};

// DEVELOPMENT
// const firebaseConfig = {
//   apiKey: "AIzaSyDqJySrD7zm8kgk16bk5xdSjPWmuMYtzx0",
//   authDomain: "simpleqr-dev.firebaseapp.com",
//   databaseURL: "https://simpleqr-dev.firebaseio.com",
//   projectId: "simpleqr-dev",
//   storageBucket: "simpleqr-dev.appspot.com",
//   messagingSenderId: "337365911625",
//   appId: "1:337365911625:web:6847b5109fa0c3b40f9798",
//   measurementId: "G-1M9RPKVS8R"
// };

//firebase.analytics();
export const app = firebase.initializeApp(firebaseConfig);
export const db = app.firestore();
export const function_ = app.functions();
export const analytics = firebase.analytics()

const advancedMatching = { em: 'nnaguirre@uc.cl' }; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching
const options = {
  autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
  debug: false, // enable logs
};
ReactPixel.init('390374558898488', advancedMatching, options);

ReactPixel.pageView(); // For tracking page view